import { cB as e, c as t } from "./ghl-ui.es369.js";
const l = e("base-icon", `
 height: 1em;
 width: 1em;
 line-height: 1em;
 text-align: center;
 display: inline-block;
 position: relative;
 fill: currentColor;
 transform: translateZ(0);
`, [t("svg", `
 height: 1em;
 width: 1em;
 `)]);
export {
  l as default
};
